// src/portal-app/nav/useHubCards.js
//
// Hub-card gating, extracted from the old HubScreen so all five tab landings
// share one implementation.
//
// The four states are load-bearing and their exact semantics were carried
// over verbatim — a wrong answer either hides a feature the tenant pays for
// or exposes one they do not have:
//
//   HIDDEN  — permission denied; the card is omitted from the array entirely.
//   LOCKED  — feature flag off. Still rendered, with an upgrade hint, never
//             tappable. Locked WINS over registered.
//   ACTIVE  — permission ok, feature ok, route registered. Tappable.
//   INERT   — permission ok, feature ok, but no route yet. Rendered flat,
//             with no affordance suggesting it can be tapped.
//
// Two short-circuits are deliberate: a card with no `permission` is always
// visible, and a missing `hasPermission` (rendered outside an AuthProvider)
// shows everything rather than blanking the app.
import { useMemo } from 'react';
import { useAuth } from '../../context/AuthContext';
import { ROUTES } from './routes';
import { HUBS } from './tabs';

export function useHubCards(tabId) {
    const auth = useAuth() || {};
    const { hasPermission, hasFeature } = auth;

    return useMemo(() => {
        const hub = HUBS[tabId];
        if (!hub || !Array.isArray(hub.cards)) return [];

        return hub.cards
            .filter((card) => !card.permission || !hasPermission || hasPermission(card.permission))
            .map((card) => {
                const locked = !!(card.feature && hasFeature && !hasFeature(card.feature));
                const state = locked ? 'locked' : (ROUTES[card.id] ? 'active' : 'inert');
                return { ...card, state };
            });
    }, [tabId, hasPermission, hasFeature]);
}

export default useHubCards;
